import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import DatePicker from 'react-datepicker';
import cn from 'classnames';

import { HBox, VBox } from '../../../../components/Box';

import LoadingField from '../../../../containers/App/Components/LoadingField/LoadingField';
import { Calendar, Check, ArrowDown } from '../../../../components/Icon';
import { Cell, List, Row } from '../../../../components/List';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import CheckboxComponent from '../../../../containers/App/Components/Checkbox/Checkbox';
import { SearchSelect } from '../../../../components/SearchSelectComponent';

import { updateSelectedTransportOrders } from '../../actions';
import { fetchTransporters } from '../../../Transporters/actions';
import { setVehicleProperty, updateSelectedVehicles } from '../../../Vehicles/actions';
import { selectTransporters } from '../../../Transporters/selectors';
import { selectWork, selectWorks } from '../../../Api/selectors';
import { REQUEST_UPDATE_SELECTED_TRANSPORT_ORDERS, TRANSPORT_ORDER_STATUS_OPTIONS } from '../../constants';
import { REQUEST_TRANSPORTERS } from '../../../Transporters/constants';

import styles from './EditTransportOrderBulkActionModal.module.css';

dayjs.extend(customParseFormat);
const STATE = {
  addedProps: {},

  download: true,
};

const Container = styled.div`
  font-size: 14px;
  .title {
    font-size: 14px;
  }

  .section {
    margin-bottom: 24px;
  }

  strong {
    margin-bottom: 24px;
  }
`;

const RequireMark = styled.span`
  margin-left: 4 px;
  font-size: 12px;
  color: red;
`;

const FIELDS = ['transporterId', 'remarks', 'datePlanned'];

const DROPDOWN_OPTIONS = {
  status: TRANSPORT_ORDER_STATUS_OPTIONS,
};

export const VEHICLE_EXTRA_COST = {
  incoming: 'extra_cost_transport_kosten_inkomend',
  outgoing: 'extra_cost_transport_kosten_uitgaand',
  other: 'extra_cost_transportation_costs',
};

/* eslint-disable react/prefer-stateless-function */
class EditTransportOrderBulkActionModalComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.fetchTransporters();
  }

  componentDidUpdate(prevProps, prevState) {}

  get transportCostType() {
    const uniqueArray = Array.from(new Map(this.props.transportOrders.map(item => [item.type, item])).values())?.map(
      t => t.type,
    );

    let type = '';
    if (uniqueArray?.length == '1' && uniqueArray?.[0] !== 'other') {
      type = VEHICLE_EXTRA_COST[uniqueArray?.[0]];
    } else {
      type = VEHICLE_EXTRA_COST.other;
    }

    return type;
  }

  get todayDate() {
    const today = dayjs().format('YYYY-MM-DD hh:mm:ss');
    return today;
  }

  get dto() {
    let properties = {
      payload: {},
    };

    if (this.state.transporterId) {
      properties.payload.transporterId = this.state.transporterId;
    }
    if (this.state.remarks) {
      properties.payload.remarks = this.state.remarks;
    }
    if (this.state.datePlanned) {
      properties.payload.datePlanned = this.state.datePlanned;
    }
    if (this.state.scheduledDate) {
      const today = dayjs().format('DD-MM-YYYY');
      properties.payload.datePlanned = this.todayDate;
    }
    // if (this.state.scheduledDate) {
    //   const today = dayjs().format('DD-MM-YYYY');
    //   properties.payload.datePlanned = dayjs(this.state.scheduledDate).format('YYYY-MM-DD hh:mm:ss');
    // }

    return properties;
  }

  get pricePerVehicle() {
    const price = this.state[this.transportCostType] / this.uniqueVehicles?.length;
    return parseFloat(price)?.toFixed(2);
  }

  get transportersOptions() {
    const options = this.props.transporters?.map(t => {
      return {
        value: t?.id,
        label: `${t?.name ?? ''} ${t?.surname ?? ''}`,
      };
    });

    return options;
  }

  get uniqueVehicles() {
    const uniqueArray = Array.from(new Map(this.props.transportOrderVehicles.map(item => [item.id, item])).values());
    return uniqueArray;
  }

  get vehicleDoneExtraCostType() {
    let extraCost = null;

    const allMatchOutgoing = this.props.transportOrders.every(order => {
      const isNlTo = order.addressTo?.country?.code === 'NL';
      return order?.type === 'outgoing' && isNlTo;
    });

    const allMatchIncoming = this.props.transportOrders.every(order => {
      const isNlFrom = order.addressFrom?.country?.code === 'NL';
      return order?.type === 'incoming' && isNlFrom;
    });

    const allMatchOther = this.props.transportOrders.every(order => {
      const isNlFrom = order.addressFrom?.country?.code === 'NL';
      return order?.type === 'other' && isNlFrom;
    });

    const allNotNlOutgoing = this.props.transportOrders.every(order => {
      const isNotNlTo = order.addressTo?.country?.code != 'NL';
      return order?.type === 'outgoing' && isNotNlTo;
    });

    const allNotNlIncoming = this.props.transportOrders.every(order => {
      const isNotNlFrom = order.addressFrom?.country?.code != 'NL';
      return order?.type === 'incoming' && isNotNlFrom;
    });

    if (allMatchOutgoing) {
      extraCost = 'extra_cost_transport_intern_outgoing';
    } else if (allMatchIncoming) {
      extraCost = 'extra_cost_transport_intern_incoming';
    }
    // Removed automatic cost addition for individual transport ('other') during completion
    // to prevent duplicate charges since costs are already added during assignment
    // else if (allMatchOther) {
    //   extraCost = 'extra_cost_transport_intern_individual';
    // }
    return extraCost;
  }

  get allTransportOrderType() {
    let type = null;
    const allMatchOutgoing = this.props.transportOrders.every(order => {
      return order?.type === 'outgoing';
    });

    const allMatchIncoming = this.props.transportOrders.every(order => {
      return order?.type === 'incoming';
    });

    const allMatchOther = this.props.transportOrders.every(order => {
      return order?.type === 'other';
    });
    if (allMatchOutgoing) {
      type = 'outgoing';
    }
    if (allMatchIncoming) {
      type = 'incoming';
    }
    if (allMatchOther) {
      type = 'other';
    }
    return type;
  }

  get vehicleDoneTransportProp() {
    const type = this.allTransportOrderType;
    let prop = null;

    if (type == 'incoming') {
      prop = 'transport_done';
    }
    if (type == 'outgoing') {
      prop = 'transport_outgoing_done';
    }
    if (type == 'other') {
      prop = 'transport_individual_done';
    }

    return prop;
  }

  get vehiclePlanTransportProp() {
    const type = this.allTransportOrderType;
    let prop = null;

    if (type == 'incoming') {
      prop = 'transport_initiated';
    }
    if (type == 'outgoing') {
      prop = 'transport_outgoing_initiated';
    }
    if (type == 'other') {
      prop = 'transport_individual_initiated';
    }

    return prop;
  }

  isAllInStatus(status) {
    let isAllInStatus = true;
    this.props.transportOrders?.forEach(transportOrder => {
      if (transportOrder.status !== status) {
        isAllInStatus = false;
      }
    });
    return isAllInStatus;
  }

  toggle(name, amount, propertyName, vehicleId) {
    this.setState({ [name]: amount || '1,00' });
    this.props.add(vehicleId, propertyName, amount || parseFloat(1));
  }

  calc(value) {
    this._t = this.timeout(() => this.setState({ [this.transportCostType]: parseFloat(value)?.toFixed(2) }), 1000, this._t);
  }

  renderVehicleExtraCostField(vehicleId, name) {
    const value = this.state[`${vehicleId}_${name}`];
    const nameState = `${vehicleId}_${name}`;
    return (
      <HBox vBottom left gap={'2px'}>
        <div>
          <label className="form-label">{this.lbl(`vehicle.property.${name}`)}</label>
          <input
            disabled={this.state.distributeAcrossVehicles === '1'}
            className="form-control"
            value={value}
            onChange={e => this.setState({ [`${vehicleId}_${name}`]: e.target.value, [`${nameState}_add`]: true })}
          />
        </div>
        <ButtonComponent
          disabled={!this.state[`${nameState}_add`]}
          style={'ButtonSoftEdit'}
          size={'btn-sm'}
          onClick={() => {
            this.setState({
              [`${nameState}_add`]: null,
            });
            this.toggle(nameState, parseFloat(value)?.toFixed(2), name, vehicleId);
          }}
        >
          <Check />
        </ButtonComponent>
      </HBox>
    );
  }

  dropdown(type) {
    const vals = DROPDOWN_OPTIONS[type];

    let options = vals?.map(val => ({
      label: this.lbl(`vehicle.property.${type}.${val}`),
      value: val,
    }));

    if (type === 'transporterId') {
      options = this.transportersOptions;
    }

    const value = options.find(o => o.value == this.state[type]);

    if (type === 'transporterId' && this.props.workTransporters) {
      return <LoadingField />;
    }

    return (
      <div className={styles.container}>
        <SearchSelect options={options} value={value} onChange={pair => this.setState({ [type]: pair.value })} />
      </div>
    );
  }

  datePicker(type) {
    let format = this.state[type]?.charAt(2) == '-' ? 'DD-MM-YYYY' : undefined;

    let selected = this.state[type] && this.state[type] !== 'null' && dayjs(this.state[type], format);
    return (
      <div className={cn('d-flex align-items-baseline', styles.containerDatePicker)}>
        <DatePicker
          className={styles.datePicker}
          dateFormat="dd-MM-yyyy"
          selected={selected && selected != 'Invalid Date' && selected.toDate()}
          onChange={date => {
            let d = dayjs(date).format('YYYY-MM-DD hh:mm:ss');
            // let d = dayjs(date).format('DD-MM-YYYY');
            d && this.setState({ [type]: d });
          }}
        />
        <Calendar className={styles.iconCalendar} />
      </div>
    );
  }

  reset() {
    this.setState({ ...STATE });
    this.props.reset();
  }

  save(options = {}) {
    const ids = this.props?.transportOrders?.map(t => t?.id);
    const vehicleIds = this.uniqueVehicles?.map(v => +v.id);
    const vehicleVinCodes = this.uniqueVehicles?.map(v => ({ id: +v.id, vin: v.vin }));
    let dto = this.dto;

    if (options?.isPlan) {
      dto.payload.status = 'initiated';
    }

    if (options?.isDone) {
      dto.payload.status = 'done';
      dto.payload.dateDone = this.todayDate;
    }

    let vehicleDto = [];

    if (this.vehiclePlanTransportProp && options?.isPlan) {
      vehicleDto?.push({
        propertyName: this.vehiclePlanTransportProp,
        propertyValue: '1',
      });
    }

    if (this.vehicleDoneExtraCostType && options?.isDone) {
      vehicleDto.push({ propertyName: this.vehicleDoneExtraCostType, propertyValue: parseFloat(121) });
    }

    if (this.vehicleDoneTransportProp && options?.isDone) {
      vehicleDto.push({ propertyName: this.vehicleDoneTransportProp, propertyValue: '1' });
    }

    if (this.pricePerVehicle && this.state.distributeAcrossVehicles === '1') {
      vehicleDto.push({ propertyName: this.transportCostType, propertyValue: this.pricePerVehicle });
      vehicleDto.push({
        propertyName: `total_transport_cost`,
        propertyValue: this.state[this.transportCostType],
      });
      vehicleDto.push({
        propertyName: `transported_vehicles`,
        propertyValue: JSON.stringify(vehicleVinCodes),
      });
    }
    this.props.setTransportOrdersProperties(ids, dto, result => {
      if (result && vehicleDto?.length) {
        this.props.updateSelectedVehicles(vehicleIds, vehicleDto);
      }
    });
    return this.props.reset();
  }

  render() {
    if (this.props.work) {
      return (
        <ModalComponent size={'modal-xl'}>
          <HBox gap={12}>
            <VBox>
              <LoadingField />
              <LoadingField />
              <LoadingField />
              <LoadingField />
              <LoadingField />
              <LoadingField />
              <LoadingField />
              <LoadingField />
            </VBox>
            <VBox>
              <LoadingField />
              <LoadingField />
              <LoadingField />
              <LoadingField />
              <LoadingField />
              <LoadingField />
              <LoadingField />
              <LoadingField />
            </VBox>
          </HBox>
        </ModalComponent>
      );
    }

    return (
      <Container>
        <ModalComponent size={'modal-xl'} onClose={() => this.reset()}>
          <div className={styles.GridContainer}>
            <div className={styles.GridItem}>
              {FIELDS?.map(type => {
                if (['transporterId']?.includes(type)) {
                  return (
                    <div className="mb-2">
                      <label className="form-label">{this.lbl(`vehicle.property.${type}`)}</label>
                      {this.dropdown(type)}
                    </div>
                  );
                }

                if (type === 'remarks') {
                  return (
                    <div className="mb-2">
                      <label className="form-label">{this.lbl(`vehicle.property.${type}`)}</label>
                      <textarea
                        value={this.state[type]}
                        onChange={evt => this.setState({ [type]: evt.target.value })}
                        className="form-control"
                      />
                    </div>
                  );
                }

                if (type === 'datePlanned') {
                  return (
                    <div className="mb-2">
                      <label className="form-label">{this.lbl(`vehicle.property.${type}`)}</label>
                      {this.datePicker(type)}
                    </div>
                  );
                }
              })}
              <VBox>
                {['datePlanned', 'transporterId']?.map(type => {
                  if (!this.state?.[type] && this.state.isPlan) {
                    return <RequireMark key={type}>{this.lbl(`transport_order.property.${type}`)}*</RequireMark>;
                  }
                })}
              </VBox>
              <div className="mb-2">
                <CheckboxComponent
                  label={this.lbl('transport_order.bulk_action.distributeAccrossVehicles')}
                  checked={this.state.distributeAcrossVehicles === '1'}
                  onChange={() => {
                    if (this.state.distributeAcrossVehicles === '1') {
                      this.setState({ distributeAcrossVehicles: '0' });
                      return;
                    }

                    this.setState({ distributeAcrossVehicles: '1' });
                  }}
                />
              </div>
              <div className="mb-2">
                <label className="form-label">{this.transportCostType}</label>
                <input
                  type="number"
                  disabled={this.state.distributeAcrossVehicles !== '1'}
                  className="form-control"
                  value={this.state?.[this.transportCostType]}
                  onChange={e => {
                    this.setState({ [this.transportCostType]: e.target.value });
                    this.calc(e.target.value);
                  }}
                />

                {this.state[this.transportCostType] && (
                  <VBox className="mt-2">
                    <span>Aantal voertuigen: {`${this.uniqueVehicles?.length}`}</span>
                    <span>Kosten per voertuig: {this.pricePerVehicle}</span>
                  </VBox>
                )}
                <div style={{ marginTop: '10px' }}>
                  <ButtonComponent
                    style={'ButtonSoftPrimaryFullWidth'}
                    disabled={!this.isAllInStatus('requested') || !this.vehiclePlanTransportProp}
                    onClick={() => {
                      if (!this.state.datePlanned || !this.state.transporterId) {
                        this.setState({ isPlan: true });
                      } else {
                        this.setState({
                          isPlan: false,
                          status: 'initiated',
                          scheduledDate: this.todayDate,
                        });
                        this.save({ isPlan: true });
                      }
                    }}
                  >
                    {!this.isAllInStatus('requested') || !this.vehiclePlanTransportProp
                      ? this.lbl('transport_order.bulk_actions.plan.notification')
                      : this.lbl('task.progress.2')}
                  </ButtonComponent>
                </div>
                {this.isAllInStatus('initiated') && (
                  <div style={{ marginTop: '10px' }}>
                    <ButtonComponent
                      style="ButtonSoftEditFullWidth"
                      disabled={!this.vehicleDoneExtraCostType}
                      onClick={() => {
                        this.save({ isDone: true });
                      }}
                    >
                      {!this.vehicleDoneExtraCostType || !this.vehicleDoneTransportProp
                        ? this.lbl('transport_order.bulk_actions.done.notification')
                        : this.lbl('transport_order.action.afronden')}
                    </ButtonComponent>
                  </div>
                )}
              </div>
            </div>
            <div className={cn(styles.GridItem, styles.SecondColumn)}>
              <div className={styles.scrollContainer}>
                <List>
                  {this.props.transportOrders
                    ?.filter(t => t.vehicle?.id || t.vehicleManual)
                    ?.map(transportOrder => {
                      return (
                        <div className="container">
                          <div className="row bg-white">
                            {/* Vehicle Information */}
                            <div className="col-md-8 p-4">
                              <div className="font-bold">
                                <b>
                                  {transportOrder?.vehicle?.brand_name
                                    ? transportOrder?.vehicle?.brand_name + ' ' + transportOrder?.vehicle?.model_name
                                    : transportOrder?.vehicleManual || '-'}
                                </b>
                              </div>
                              <div className="text-sm text-gray-600 flex flex-wrap items-center gap-x-4">
                                <br />
                                <strong>Id:</strong> {transportOrder?.vehicle?.id ?? '-'}
                                <br />
                                <strong>Kenteken:</strong> {transportOrder?.vehicle?.regplate ?? '-'}
                                <br />
                                <strong>Vin:</strong> {transportOrder?.vehicle?.vin ?? '-'}
                              </div>
                              {!transportOrder?.vehicleManual && (
                                <div className="mt-2">
                                  {this.renderVehicleExtraCostField(
                                    transportOrder?.vehicle?.id,
                                    VEHICLE_EXTRA_COST[transportOrder?.type],
                                  )}
                                </div>
                              )}
                            </div>

                            {/* Transport Company Information */}
                            <div className="col-md-4 d-flex flex-column justify-content-center text-center">
                              <div className="text-lg font-bold">{transportOrder?.companyFrom?.name}</div>
                              <ArrowDown className="text-gray-600 my-2 mx-auto" />
                              <div className="text-lg font-bold">{transportOrder?.companyTo?.name}</div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </List>
              </div>
            </div>
          </div>
          <div className="d-flex gap-2 justify-content-end mt-3">
            {/* <ButtonComponent style={'ButtonSoftEdit'} type="submit" onClick={this.save.bind(this)}>
              {this.lbl(`confirm`)}
            </ButtonComponent> */}
            <ButtonComponent style={'ButtonSoftDelete'} onClick={this.props.reset}>
              {this.lbl(`cancel`)}
            </ButtonComponent>
          </div>
        </ModalComponent>
      </Container>
    );
  }
}

EditTransportOrderBulkActionModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    workTransporters: selectWorks([REQUEST_TRANSPORTERS]),
    work: selectWork(REQUEST_UPDATE_SELECTED_TRANSPORT_ORDERS),
    transporters: selectTransporters(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,

    fetchTransporters(callback) {
      dispatch(fetchTransporters(callback));
    },
    add(vehicleId, name, value, callback) {
      dispatch(setVehicleProperty(vehicleId, name, parseFloat(value), callback));
    },
    setTransportOrdersProperties(ids, dto, callback) {
      dispatch(updateSelectedTransportOrders(ids, dto, callback));
    },
    updateSelectedVehicles(vehicleIds, properties, callback) {
      dispatch(updateSelectedVehicles(vehicleIds, properties, callback));
    },
    addVehicleExtraCost(vehicleIds, name, callback) {
      const transportDoneCost = 121;
      dispatch(
        updateSelectedVehicles(vehicleIds, [{ propertyName: name, propertyValue: parseFloat(transportDoneCost) }], callback),
      );
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const EditTransportOrderBulkActionModal = compose(
  withConnect,
  withRouter,
  injectIntl,
)(EditTransportOrderBulkActionModalComp);
